module.exports = __webpack_public_path__ + "static/img/rank_78.afe4054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_78.png
// module id = qQGC
// module chunks = 1